<template>
    <div>
        <VueCtkDateTimePicker
            v-model="value"
            :label="label"
            :format="format"
            :formatted="formatted"
        >
        </VueCtkDateTimePicker>
        <input type="hidden" :id="id" :name="name" v-model="value" v-bind:required="required">
    </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

    export default {
        components: {
            VueCtkDateTimePicker,
        },
        props: {
            id: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                label: 'Select DateTime',
                format: 'YYYY-MM-DD HH:mm:ss',
                formatted: 'YYYY-MM-DD HH:mm:ss',
                onlyTime: true,
            }
        }
    }
</script>
